import React, {PropTypes as T} from 'react';
import Button from '../../../common/button';
import PasswordBox from '../../passwordbox';
import translate from '../../../../utils/translate';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class GAPasswordProtectedPriceType extends React.Component {
  static propTypes = {
    eventId:              T.string,
    priceType:            T.object,
    priceFormatted:       T.string,
    updateCategoryBasket: T.func,
    categoryId:           T.string,
    isUnlockingPriceType: T.oneOfType([T.bool, T.number])
  };

  state = {
    passwordBoxVisible: false
  };

  showPasswordBox = () => {
    this.setState({ passwordBoxVisible: true });
  };

  render () {
    const { priceType } = this.props;

    return (
      <div data-component="password-protected-pricetype">
        <div
          className="ismmodal__option"
          onClick={this.showPasswordBox}
          tabIndex="0"
          role="button"
          data-component="password-protected-pricetype">
          <div className="ismmodal__option__label">
            <h3
              className="ismmodal__option__label__title"
              data-component="gapricetype-title">{priceType.name}</h3>
          </div>
          <div className="ismmodal__option__control">
            <ReactCSSTransitionGroup
              transitionName="unlock-pricetype-button-transition"
              transitionEnter={false}
              transitionLeaveTimeout={250}>
              {
                !this.state.passwordBoxVisible &&
                <Button primary outlined flex
                  className="ismmodal__option__btn--unlock"
                  data-component="unlock-pricetype-button">
                  {translate('ismModule', 'UNLOCK')}
                </Button>
              }
            </ReactCSSTransitionGroup>
          </div>
        </div>
        <ReactCSSTransitionGroup
          transitionName="passwordBox__transition"
          transitionEnterTimeout={400}
          transitionLeaveTimeout={400}>
          {
            this.state.passwordBoxVisible &&
              <PasswordBox
                key="passwordbox"
                priceType={priceType}
                eventId={this.props.eventId}
                isUnlockingPriceType={this.props.isUnlockingPriceType} />
          }
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/generaladmission/gapricetype/password_protected_pricetype.js